import type { FacetSnapshotForUpdate } from "./facet-workspace-update-helpers";
import { resolvedEtlJsonForPersist } from "./facet-workspace-update-helpers";

/** Wrapped `{ etl: { ds, ops } }` or bare `{ ds, ops }` pipeline document. */
export function resolveEtlNodeFromDocument(doc: Record<string, unknown>): Record<string, unknown> | null {
    const wrapped = doc.etl;
    if (wrapped != null && typeof wrapped === "object" && !Array.isArray(wrapped)) {
        return wrapped as Record<string, unknown>;
    }
    if (doc.ops != null || doc.ds != null) {
        return doc;
    }
    return null;
}

export function isWrappedEtlDocument(doc: Record<string, unknown>): boolean {
    return doc.etl != null && typeof doc.etl === "object" && !Array.isArray(doc.etl);
}

export function writeEtlNodeToDocument(
    doc: Record<string, unknown>,
    etlNode: Record<string, unknown>
): Record<string, unknown> {
    if (isWrappedEtlDocument(doc)) {
        return { ...doc, etl: etlNode };
    }
    const { etl: _ignored, ...rest } = doc;
    return { ...etlNode, ...rest };
}

export function resolveFacetEtlDocument(
    jsonDraft: string,
    facet?: FacetSnapshotForUpdate | null
): Record<string, unknown> | null {
    if (jsonDraft.trim()) {
        try {
            const parsed = JSON.parse(jsonDraft) as Record<string, unknown>;
            if (resolveEtlNodeFromDocument(parsed)) return parsed;
        } catch {
            /* ignore */
        }
    }
    if (!facet) return null;
    const stored = resolvedEtlJsonForPersist(facet);
    return resolveEtlNodeFromDocument(stored) ? stored : null;
}
